import Hero from "./Hero";

const Home = () => {
    return(
        <div>
            <Hero text="Current River Levels" />
        </div>
    );
};

export default Home;